import * as types from '../mutation-types'

const state = {
  call: '',
  bulkCall: '',
  calledAt: '',
  selectedCallList: '',
  lastPositionId: '',

  assignPageStatus: {
    uid: '',
    status: ''
  },

  client: null,
  job: null,
  statusList: []
}
const getters = {
  /**
   * Assign page data
   */
  getJobDetails: state => state.job,
  clientDetails: state => state.client,
  employeeStatusList: state => state.statusList,


  selectedCallId: state => state.call.id,
  callStartTime: state => state.call.start,
  callEndTime: state => state.call.end,
  skillId: state => state.call.skill_id,
  callStatus: state => state.call.status_id,
  callDate: state => state.calledAt,
  getSelectedCallList: state => state.selectedCallList,
  selectedCallSkillname: state => state.call.skill&&state.call.skill.name?state.call.skill.name:'',

  /* Getters for bulk call operation*/
  noOfUnassignCall: state => state.bulkCall.unassigned,
  selectedBulkCallId: state => state.bulkCall.id,
  bulkCallStartTime: state => state.bulkCall.start,
  bulkCallEndTime: state => state.bulkCall.end,
  bulkCallSkillId: state => state.bulkCall.skill_id,
  selectedBulkCalls: state => state.bulkCall.call,
  bulkCallSkillName: state => state.bulkCall.skills&&state.bulkCall.skills.length&&state.bulkCall.skills[0].name?state.bulkCall.skills[0].name:'',

  getLastPositionId: state => state.lastPositionId,
  getAssignPageStatus: state => state.assignPageStatus,
}
const actions = {
  setCall({ commit, state }, data) {
    commit(types.SET_SELECTED_CALL, data);
    //console.log('callData',data);
  },
  setBulkCall({ commit, state }, data) {
    commit(types.SET_SELECTED_BULK_CALL, data);
    //console.log('callData',data);
  },
  setSelectedCallList({ commit, state }, data) {
    commit(types.SET_SELECTED_CALL_LIST, data);
    //console.log('callData',data);
  },
  setLastPositionId({ commit, state }, data) {
    commit(types.SET_LAST_POSITION_ID, data);
    //console.log('callData',data);
  },
  setAssignPageStatus({ commit, state }, data) {
    commit(types.SET_LAST_CALL_ASSIGN_STATUS, data);
    // console.log('callData',data);
  },

  saveJobDetails({ commit, state }, data) {
    commit(types.SAVE_JOB_DETAILS, data);
    // console.log('saveJobDetails', data);
  },
  saveClientDetails({ commit, state }, data) {
    commit(types.SAVE_CLIENT_DETAILS, data);
    // console.log('callData',data);
  },
  saveStatusList({ commit, state }, data) {
    commit(types.SAVE_STATUS_LIST, data);
    // console.log('callData',data);
  }
}
const mutations = {
  [types.SAVE_JOB_DETAILS](state, data) {
    // console.log('SAVE_JOB_DETAILS',data);
    state.job = data;
  },
  [types.SAVE_CLIENT_DETAILS](state, data) {
    state.client = data;
  },
  [types.SAVE_STATUS_LIST](state, data) {
    state.statusList = data;
  },

  [types.SET_SELECTED_CALL](state, data) {
    state.call = data;
    state.calledAt = data.called_at;
  },
  [types.SET_SELECTED_BULK_CALL](state, data) {
    state.bulkCall = data;
    state.calledAt = data.called_at;
  },
  [types.SET_SELECTED_CALL_LIST](state, data) {
    state.selectedCallList = data;
  },
  [types.SET_LAST_POSITION_ID](state, data) {
    state.lastPositionId = data;
  },
  [types.SET_LAST_CALL_ASSIGN_STATUS](state, data) {
    state.assignPageStatus.uid = data.uid;
    state.assignPageStatus.status = data.status;
    //console.log('SET_LAST_CALL_ASSIGN_STATUS',state.assignPageStatus);
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/calls.js